import '@mockup/func/pollyfil';
import '@mockup/func/globals';

import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import aos from 'aos';

import { App } from '@mockup/func/globals/App';
import '@mockup/func/globals/App.format';
import '@mockup/func/globals/App.flowguide';
import '@mockup/func/globals/App.ipvalidationAuto';

import Collapse from 'bootstrap/js/dist/collapse';
import Tab from 'bootstrap/js/dist/tab';

import env from '@mockup/func/globals/environment';
import tableSorter from '@mockup/func/globals/table.sorter';
import tableExpander from '@mockup/func/globals/table.expander';
import newsletterSignup from './func/globals/newsletter.signup';
import contactme from './func/globals/contactme';
import feedback from './func/globals/feedback';
import pagedtable from './func/globals/table.paged';
import accordion from './func/globals/accordion';
import lightbox from './func/globals/lightbox';
import leaveGuide from './func/globals/guide.leave';
import tabs from './func/globals/tabs';
import rangeSlider from './func/globals/slider.range';
import format from './func/globals/format'; // used!
import fileUploader from './func/globals/fileuploader';
import siteSearch from './func/search';
import Dialog from './func/globals/dialog';
import Modal from './func/globals/modal';
import Toast from './func/globals/toast';

global.bootstrap = window.bootstrap = { Collapse, Tab };
window.alertify = window.dialog = new Dialog({
    labels: {
        OK: 'Ok',
        CANCEL: 'Annuller'
    }
});
window.modal = new Modal();
window.toast = new Toast();

if (env.isDevelopment) {
    // eslint-disable-next-line no-console
    console.log(
        `%cRunning%c${env.NODE_ENV}`,
        'font-size:1.1rem;background:#000;color:#fff;border-radius:3px 0 0 3px;padding:0 8px;text-transform:uppercase;',
        'font-size:1.1rem;background:#de3000;color:#fff;border-radius:0 3px 3px 0;padding:0 8px;text-transform:uppercase;'
    ); // eslint-disable-line no-console
}

// change className of html from .noJS to .hasJS.
(function (el) {
    el.className = el.className.replace('no-js', 'has-js');
})(document.documentElement);

export const core = {
    // App.common.init runs on all pages
    init: function () {
        svg4everybody();

        aos.init({
            once: true,
            offset: 200,
            duration: 500
        });

        App.format.init();

        lightbox.init();
        tabs.init();
        accordion.init();
        feedback.init();
        newsletterSignup.init();
        contactme.init();
        leaveGuide.init();
        tableExpander.init();
        pagedtable.init();
        fileUploader.init();
        tableSorter.init();
        siteSearch.init();

        rangeSlider.init();

        // Sitecore forms
        if (document.querySelector('.ip-sitecore-forms')){
            import('@mockup/func/sitecoreForms/index').then((module) => new module.default());
        }
        // Header
        if (document.querySelector('.site-header')){
            import('@mockup/func/header/index').then((module) => new module.default());
        }

        if (document.querySelector('.js-contact-banner')){
            import('@mockup/func/contact-banner/index').then((module) => new module.default());
        }

        // viemoVideo
        if (document.getElementById('hero-video')) {
            window.addEventListener('CookiebotOnAccept', function (_) {
                if (Cookiebot.consent.marketing) {
                    import('@mockup/func/viemoVideo/index').then((module) => new module.default());
                }
            });
        }

        $(window)
            .on('hashchange', function () {
                // Timeout hack, to insure that the code i running last at que pipeline
                //
                setTimeout(function () {
                    var hashTabVal = hash.get('tab');
                    if (!$('.tabs .tabs-list-item a').eq(hashTabVal).hasClass('active')) {
                        $('.tabs .tabs-list-item a').eq(hashTabVal).trigger('click');
                    }

                    var hashAccordionVal = hash.get('accordion');
                    if (
                        !$('.accordion .accordion-header > a[href="#' + hashAccordionVal + '"]')
                            .parents('.accordion')
                            .hasClass('open')
                    ) {
                        $('.accordion .accordion-header > a[href="#' + hashAccordionVal + '"]').trigger('click');
                    }
                }, 1);
            })
            .on('click', function (e) {
                if (
                    !$(e.target).hasClass('table-flex-elm--filter-header') &&
                    !$(e.target).parents('.table-flex-elm--filter-header ').length
                ) {
                    $('.table-flex-elm--filter-sorting ').removeClass('show');
                }
            });

        // Scrolls first input-item into view, with validation error, when a button is clicked
        for (const btn of [...document.getElementsByClassName('btn')]) {
            // eslint-disable-next-line no-loop-func
            btn.addEventListener('click', () => {
                // eslint-disable-next-line no-unused-expressions
                const firstError = [...document.getElementsByTagName('input')].find((i) =>
                    i.closest('.fu')?.classList.contains('error')
                );
                if (firstError) {
                    $('html, body').animate({ scrollTop: $(firstError).offset().top - 20 }, 800);
                }
            });
        }
    }
};
